import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { withAlert } from 'react-alert';
import { withStyles } from '@material-ui/core/styles';
import { Link, withRouter } from 'react-router-dom';

const styles = theme => ({});

class TermsPage extends Component {
	render() {
		return <div>Terms of Use</div>;
	}
}

TermsPage.propTypes = {
	classes: PropTypes.object.isRequired
};

const WithStyles = withStyles(styles)(TermsPage);

const WithAlert = withAlert(WithStyles);

export default withRouter(WithAlert);
